import type { StorageAdapter } from "../adapter/adapter.js";

/** The tables wiped by "delete all" / "replace". Settings are intentionally excluded. */
const DATA_TABLES = [
  "tasks", "recurrence_rules", "recurrence_overrides", "labels", "topics", "calendars",
] as const;

export class BackupRepository {
  constructor(private readonly db: StorageAdapter) {}

  /** Hard-delete all data (tasks, rules, overrides, labels, topics, calendars). Keeps settings. */
  async wipeData(): Promise<void> {
    for (const table of DATA_TABLES) {
      await this.db.execute(`DELETE FROM ${table}`);
    }
  }
}
